import { css } from 'lit';

export default css`
  :host {
    --max-width: 400px;
    --max-height: 200px;
    --hide-delay: 0ms;
    --show-delay: 150ms;

    display: contents;
  }

  .preview {
    --background-color: var(--webmodule-panel-background-color);
    --border-color: var(--webmodule-panel-border-color);
    --border-width: var(--webmodule-panel-border-width);
    --border-radius: var(--webmodule-border-radius-medium);
    --shadow: var(--webmodule-shadow-large);
  }

  .preview::part(popup) {
    z-index: var(--webmodule-z-tooltip);
  }

  .preview[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .preview[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .preview[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .preview[placement^='right']::part(popup) {
    transform-origin: left;
  }

  .preview__panel {
    background: var(--background-color);
    border: solid var(--border-width) var(--border-color);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow);
    padding: var(--webmodule-spacing-medium);
    min-width: 200px;
    max-width: var(--max-width);
  }

  .preview__header {
    font-weight: bold;
    margin-bottom: var(--webmodule-spacing-small);
  }

  .preview__body {
    --max-block-size: var(--max-height);
  }

  ::slotted([slot='content']) {
    white-space: pre-wrap;
  }
`;
